import { render } from "./MQuantitySelector.vue?vue&type=template&id=0b479fec&scoped=true"
import script from "./MQuantitySelector.vue?vue&type=script&lang=js"
export * from "./MQuantitySelector.vue?vue&type=script&lang=js"

import "./MQuantitySelector.vue?vue&type=style&index=0&id=0b479fec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b479fec"]])

export default __exports__